import SkapaButton, {
  type ButtonAttributes,
  type ButtonProps,
  type ButtonType,
} from "@ingka/button";

const Button = (props: ButtonProps & ButtonAttributes) => {
  return <SkapaButton prefix="saleslead__" {...props} />;
};

export { Button, type ButtonType, type ButtonProps, type ButtonAttributes };
